import { ALERT_SESSION, ALL_PARTS, CLEAR_FILTER_PARTS, FILTER_PARTS, SEARCH_PARTS } from "../action-types";
import axios from "axios"
import {url, urlFront} from "../../App.js";


export const getAllParts = () => {
    return async (dispatch) => {
        try {
            const config = {
                method: 'get',
                url: `${url}/parts/`,
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            };
            const response = await axios(config)
            dispatch({
                type: ALL_PARTS,
                payload: response.data
            })
        } catch (error) {
            const errorResponse = {};
            errorResponse.error = error.message;
            if(error.response.status === 401) {
                dispatch({
                    type: ALERT_SESSION,
                    payload: true
                })

                setTimeout(() => {
                    localStorage.clear('globalState')
                    window.location.replace(urlFront)
                }, [3000])
                
            }  
            return errorResponse;    
        } 
    }
}
export const clearFilterParts = () => {
    return {
      type: CLEAR_FILTER_PARTS,
    };
  };

  export const getFilterParts = (filtros) => {
    return async (dispatch) => {
        try {
            const config = {
                method: 'post',
                url: `${url}/parts/filter`,
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
                data: filtros
            };
            const response = await axios(config)
            if (response.status === 200) {
                dispatch({
                    type: FILTER_PARTS,
                    payload: response.data.parts
                })
            }
            else if (response.status === 204) {
                dispatch({
                    type: FILTER_PARTS,
                    payload: ["Sin resultados"]
                })
            }
        } catch (error) {
            const errorResponse = {};
            errorResponse.error = error.message;
            if(error.response.status === 401) {
                dispatch({
                    type: ALERT_SESSION,
                    payload: true
                })

                setTimeout(() => {
                    localStorage.clear('globalState')
                    window.location.replace(urlFront)
                }, [3000])
                
            }  
            return errorResponse;    
        } 
    }
}

export const getSearchParts= (partialName) => {
    return async (dispatch) => {
        try {
            const config = {
                method: 'get',
                url: `${url}/parts/search/${partialName}`,
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            };
            const response = await axios(config)
            if (response.status === 200) {
                dispatch({
                    type: SEARCH_PARTS,
                    payload: response.data.parts
                })
            }
            else if (response.status === 204) {
                dispatch({
                    type: SEARCH_PARTS,
                    payload: ["Sin resultados"]
                })
            }
        } catch (error) {
            const errorResponse = {};
            errorResponse.error = error.message;
            if(error.response.status === 401) {
                dispatch({
                    type: ALERT_SESSION,
                    payload: true
                })

                setTimeout(() => {
                    localStorage.clear('globalState')
                    window.location.replace(urlFront)
                }, [3000])
                
            }  
            return errorResponse;    
        } 
    }
}